import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-otp-limit-modal',
  templateUrl: './otp-limit-modal.component.html',
  styleUrls: ['./otp-limit-modal.component.scss'],
})
export class OtpLimitModalComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {},
    public dialogRef: MatDialogRef<OtpLimitModalComponent>
  ) {}

  ngOnInit(): void {}

  close(): void {
    this.dialogRef.close();
  }
}
